import React from 'react'

function NotFound() {
    return (
        <div className='m-t-40'><h1>Error 404. Page not found.</h1>;</div>
    )
}

export default NotFound